module.exports = __webpack_public_path__ + "static/kalkhoffGeometry-82d818db2a0d7bb770213e00f1903298.jpg";